import React from "react";
import styles from "./sectionControlUtil.module.css";
import E3Button from "../InputControls/E3Button";
import E3Checkbox from "../InputControls/E3Checkbox";
import E3CheckboxGroup from "../InputControls/E3CheckboxGroup";
import E3Combobox from "../InputControls/E3Combobox";
import E3Selectbox from "../InputControls/E3Selectbox";
import E3DateRange from "../InputControls/E3DateRange";
import E3DateTime from "../InputControls/E3DateTime";
import E3FileMulti from "../InputControls/E3FileMulti";
import E3FileSingle from "../InputControls/E3FileSingle";
import E3Input from "../InputControls/E3Input";
import E3InputMulti from "../InputControls/E3InputMulti";
import E3InputRange from "../InputControls/E3InputRange";
import E3Textarea from "../InputControls/E3Textarea";
import E3RadioGroup from "../InputControls/E3RadioGroup";
import E3Switch from "../InputControls/E3Switch";
import E3DynamicLinkList from "../InputControls/E3DynamicLinkList";
import { existChk } from "e3-common/utils/controlsUtil";
import { Tooltip } from "react-tooltip";
import { E3ComboboxCheckList, E3FileUpDown } from "e3-components";

export const bindControl = (key, control) => {
  if (key.startsWith("txt")) {
    if (control.button) {
      return (
        <>
          <div className={"input_icon_groub"}>
            <E3Input
              ref={control.ref}
              controlWidth={control.controlWidth}
              {...control.controlOption}
            />
            <E3Button
              ref={control.button.ref}
              buttonType={control.button.buttonType}
              onClick={control.button.onClick}
              label={control.button.label}
              authBtn={control.button.authBtn}
              checkAuth={control.button.checkAuth}
              colorType={control.button.colorType}
              iconType={control.button.iconType}
              {...control.button.controlOption}
            />
          </div>
        </>
      );
    }
    return (
      <E3Input
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("rtxt")) {
    if (control.button) {
      return (
        <>
          <div className="input_btn_wrap">
            <E3InputRange
              ref={control.ref}
              controlWidth={control.controlWidth}
              {...control.controlOption}
            />
            <div className="input_btn_box">
              {control.button.search ? (
                <E3Button
                  ref={control.button.search.ref}
                  buttonType={control.button.search.buttonType}
                  iconType={"btn_search"}
                  // className={'floatRightOutSearch'}
                  onClick={control.button.search.onClick}
                  label={control.button.search.label}
                  authBtn={control.button.search.authBtn}
                  checkAuth={control.button.search.checkAuth}
                  colorType={control.button.search.colorType}
                  visible={control.button.search.visible}
                  {...control.button.search.controlOption}
                />
              ) : null}

              {control.button.refresh ? (
                <E3Button
                  ref={control.button.refresh.ref}
                  buttonType={control.button.refresh.buttonType}
                  iconType={"btn_reset"}
                  // className={'floatRightOutRefresh'}
                  onClick={control.button.refresh.onClick}
                  label={control.button.refresh.label}
                  authBtn={control.button.refresh.authBtn}
                  checkAuth={control.button.refresh.checkAuth}
                  colorType={control.button.refresh.colorType}
                  visible={control.button.refresh.visible}
                  {...control.button.refresh.controlOption}
                />
              ) : null}
            </div>
          </div>
        </>
      );
    }
    return (
      <E3InputRange
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("mtxt")) {
    if (control.button) {
      return (
        <>
          <div className="input_btn_wrap" style={{ border: "1px solid blue" }}>
            <E3InputMulti
              ref={control.ref}
              controlWidth={control.controlWidth ?? "wpx_150"}
              {...control.controlOption}
            />
            <div className="input_btn_box" style={{ marginTop: "5px" }}>
              {control.button.search ? (
                <E3Button
                  ref={control.button.search.ref}
                  iconType={"btn_search"}
                  buttonType={control.button.search.buttonType}
                  onClick={control.button.search.onClick}
                  label={control.button.search.label}
                  authBtn={control.button.search.authBtn}
                  checkAuth={control.button.search.checkAuth}
                  colorType={control.button.search.colorType}
                  {...control.button.search.controlOption}
                />
              ) : null}

              {control.button.refresh ? (
                <E3Button
                  ref={control.button.refresh.ref}
                  buttonType={control.button.refresh.buttonType}
                  iconType={"btn_reset"}
                  onClick={control.button.refresh.onClick}
                  label={control.button.refresh.label}
                  authBtn={control.button.refresh.authBtn}
                  checkAuth={control.button.refresh.checkAuth}
                  colorType={control.button.refresh.colorType}
                  {...control.button.refresh.controlOption}
                />
              ) : null}
            </div>
          </div>
        </>
      );
    }
    return (
      <E3InputMulti
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("cbo")) {
    if (control.button) {
      return (
        <>
          <E3Combobox
            ref={control.ref}
            controlWidth={control.controlWidth}
            {...control.controlOption}
          />
          <E3Button
            ref={control.button.ref}
            buttonType={control.button.buttonType}
            onClick={control.button.onClick}
            label={control.button.label}
            authBtn={control.button.authBtn}
            checkAuth={control.button.checkAuth}
            colorType={control.button.colorType}
            iconType={control.button.iconType}
            {...control.button.controlOption}
          />
        </>
      );
    }
    return (
      <E3Combobox
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("cbc")) {
    if (control.button) {
      return (
        <>
          <E3ComboboxCheckList
            ref={control.ref}
            controlWidth={control.controlWidth}
            {...control.controlOption}
          />
          <E3Button
            ref={control.button.ref}
            buttonType={control.button.buttonType}
            onClick={control.button.onClick}
            label={control.button.label}
            authBtn={control.button.authBtn}
            checkAuth={control.button.checkAuth}
            colorType={control.button.colorType}
            iconType={control.button.iconType}
            {...control.button.controlOption}
          />
        </>
      );
    }
    return (
      <E3ComboboxCheckList
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("sel")) {
    if (control.button) {
      return (
        <>
          <E3Selectbox
            ref={control.ref}
            controlWidth={control.controlWidth}
            {...control.controlOption}
          />
          <E3Button
            ref={control.button.ref}
            buttonType={control.button.buttonType}
            onClick={control.button.onClick}
            label={control.button.label}
            authBtn={control.button.authBtn}
            checkAuth={control.button.checkAuth}
            colorType={control.button.colorType}
            iconType={control.button.iconType}
            {...control.button.controlOption}
          />
        </>
      );
    }
    return (
      <E3Selectbox
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("dt")) {
    return (
      <E3DateTime
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("dr")) {
    return <E3DateRange ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("chk")) {
    return <E3Checkbox ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("gchk")) {
    return <E3CheckboxGroup ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("txa")) {
    return <E3Textarea ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("fs")) {
    return <E3FileSingle ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("fm")) {
    return <E3FileMulti ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("rdo")) {
    return <E3RadioGroup ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("swi")) {
    return <E3Switch ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("dyl")) {
    return <E3DynamicLinkList ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("fud")) {
    return <E3FileUpDown ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("btn")) {
    return <E3Button {...control} />;
  }
};

/**
 * Form Section 과 Search Section에서 사용되는 Table 영역을 자동 생성함
 * colSpan, rowSpan 지원
 * ..param {*} formControls
 * ..param {*} numOfCols
 * ..returns
 */
export const createSectionTableLayout = (formControls, numOfCols, options) => {
  const keys = Object.keys(formControls);

  let hiddenControls = [];

  let cellCnt = 0;
  for (let keyIndex = 0; keyIndex < keys.length; keyIndex++) {
    const key = keys[keyIndex];
    const control = formControls[key];

    if (control?.controlOption?.hidden === true) {
      hiddenControls.push({ key, control }); // hidden 컨트롤 분리
    } else {
      cellCnt += ((control.colSpan ?? 1) + 1) * (control.rowSpan ?? 1);
    }
  }

  const colCnt = numOfCols * 2;

  const rowCnt = Math.ceil(cellCnt / colCnt); // ceil을 사용해 소수점을 올림

  let rows = [];
  for (let i = 0; i < rowCnt; i++) {
    let cols = [];
    for (let j = 0; j < colCnt; j++) {
      cols.push(0);
    }
    rows.push(cols);
  }

  let rowNo = 0;
  let colNo = 0;
  for (let keyIndex = 0; keyIndex < keys.length; keyIndex++) {
    const key = keys[keyIndex];
    const control = formControls[key];
    if (!existChk(control) || control?.controlOption?.hidden === true) continue;

    while (1) {
      if (rows[rowNo][colNo] === 0) {
        break;
      }
      colNo++;
      if (colNo >= colCnt) {
        rowNo++;
        colNo = 0;
      }
    }

    const v = { key: key, keyIndex: keyIndex, rowNo: rowNo };

    if (key.startsWith("lbl")) {
      rows[rowNo][colNo] = handleLabel(control, options, v);
      colNo++;

      if (control.colSpan && control.colSpan > 1) {
        handleColSpan(rows, rowNo, colNo, control);
      }

      continue;
    }

    rows[rowNo][colNo] = handleLabel(control, options, v);

    if (control.rowSpan && control.rowSpan > 1) {
      handleRowSpan(rows, rowNo, colNo, control);
    }
    colNo++;

    const component = bindControlProxy(key, control);
    rows[rowNo][colNo] = (
      <td
        key={`td_${keyIndex}`}
        className={`${control.tdWidth ?? ""} ${options?.tdClass ?? ""}`}
        {...(control.colSpan && { colSpan: control.colSpan })}
        {...(control.rowSpan && { rowSpan: control.rowSpan })}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {component}
          {control.afterText && (
            <span ref={control.afterText.ref}>{control.afterText.text}</span>
          )}
        </div>
      </td>
    );
    if (control.rowSpan && control.rowSpan > 1) {
      handleRowSpan(rows, rowNo, colNo, control);
    }
    colNo++;

    if (control.colSpan && control.colSpan > 1) {
      handleColSpan(rows, rowNo, colNo, control);
    }

    if (colNo >= colCnt) {
      colNo = 0;
      rowNo++;
    }
  }

  if (hiddenControls.length > 0) {
    const lastRow = [];
    hiddenControls.forEach(({ key, control }, index) => {
      const component = bindControlProxy(key, control);
      lastRow.push(
        <td
          key={`td_hidden_${index}`}
          className={`${control.tdWidth ?? ""} ${options?.tdClass ?? ""}`}
          colSpan={control.colSpan || colCnt}
          style={{ display: "none" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {component}
            {control.afterText && (
              <span ref={control.afterText.ref}>{control.afterText.text}</span>
            )}
          </div>
        </td>
      );
    });
    rows.push(lastRow);
  }

  for (let i = rows.length - 1; i >= 0; i--) {
    if (rows[i]?.length) {
      for (let j = rows[i].length - 1; j >= 0; j--) {
        if (rows[i][j] === 0) {
          rows[i][j] = null;
        }
      }
    }
  }

  return rows;
};

const bindControlProxy = (key, control) => {
  let beforeComponentArr = [];
  let afterComponentArr = [];
  if (control?.beforeComponents) {
    const keys = Object.keys(control?.beforeComponents);
    beforeComponentArr = keys?.map((item) => {
      return {
        key: item,
        control: control?.beforeComponents[item],
      };
    });
  }

  if (control?.afterComponents) {
    const keys = Object.keys(control?.afterComponents);
    afterComponentArr = keys?.map((item) => {
      return {
        key: item,
        control: control?.afterComponents[item],
      };
    });
  }

  return (
    <>
      {additional(beforeComponentArr)}
      {bindControl(key, control)}
      {additional(afterComponentArr)}
    </>
  );
};

const additional = (additionalComponentArr = []) => {
  const result = additionalComponentArr.length
    ? additionalComponentArr.map((item) => {
        return bindControl(item.key, item.control);
      })
    : null;

  return result;
};

// label 처리
const handleLabel = (control, options, v) => {
  const { key, keyIndex } = v || {};
  const { align, colSpan, cssClass } = control.labelOption || {};

  const textAlign = align ? styles[align] : styles["left"];

  return control.label ? (
    <th
      key={`th_${keyIndex}`}
      className={`${control.labelWidth ?? ""} ${
        options?.tdClass ?? ""
      } ${textAlign} ${cssClass ?? ""}`}
      {...(control.rowSpan && { rowSpan: control.rowSpan })}
      {...(colSpan && { colSpan: colSpan })}
    >
      <label
        className={control.validation?.required ? `req` : ""}
        id={key + "label"}
      >
        {control.label}
        {handleToolTip(control, v)}
      </label>
    </th>
  ) : null;
};

// colSpan 처리
const handleColSpan = (rows, rowNo, colNo, control) => {
  for (let colSpanCnt = 1; colSpanCnt < control.colSpan; colSpanCnt++) {
    rows[rowNo][colNo] = null;
    if (control.rowSpan > 1) {
      for (
        let rowSpanIndex = 1;
        rowSpanIndex < control.rowSpan;
        rowSpanIndex++
      ) {
        rows[rowNo + rowSpanIndex][colNo] = null;
      }
    }
    colNo++;
  }
};

// rowSpan 처리
const handleRowSpan = (rows, rowNo, colNo, control) => {
  for (let rowSpanIndex = 1; rowSpanIndex < control.rowSpan; rowSpanIndex++) {
    rows[rowNo + rowSpanIndex][colNo] = null;
  }
};

// create tooltip
const handleToolTip = (control, v) => {
  const { tooltip, tooltipMessage } = control || {};
  const { keyIndex, rowNo } = v || {};

  return tooltip ? (
    <>
      <svg
        data-tooltip-id={`my-tooltip-${keyIndex} + ${rowNo}`}
        data-tooltip-html={tooltipMessage ?? ""}
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="question-circle"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className="svg-inline--fa fa-question-circle fa-w-16 fa-sm"
        style={{
          // verticalAlign: '-0.125em',
          height: "1em",
          fontSize: "0.875em",
          width: "1em",
        }}
      >
        <path
          fill="currentColor"
          d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
          className=""
        ></path>
      </svg>
      <Tooltip
        id={`my-tooltip-${keyIndex} + ${rowNo}`}
        place="bottom"
        style={{
          zIndex: 9999,
          textAlign: "left",
          backgroundColor: "white",
          color: "black",
          borderRadius: "15px",
        }}
        opacity={1}
        border={"black solid 1px"}
      />
    </>
  ) : null;
};
